import { useFragment } from '@apollo/client/react';
import { BTC_GAME_FRAGMENT } from '@optools/services/operator-gateway/btc/fragments';
import { PipelineList } from '@optools/tools/btc-tools/components/pipeline-list';
import { ProvisionPipelineButton } from '@optools/tools/btc-tools/components/provision-pipeline-button';
import { getMediaForProvisioning } from '@optools/tools/btc-tools/utils/provision';
import { createFileRoute, useParams, useSearch } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/btc-tools/schedule/$gamePk/pipelines/')({
  component: RouteComponent,
});

export function RouteComponent() {
  const { date } = useSearch({ from: '/_auth/btc-tools/schedule' });
  const { gamePk } = useParams({ from: '/_auth/btc-tools/schedule/$gamePk' });

  const gameFragment = useFragment({
    fragment: BTC_GAME_FRAGMENT,
    fragmentName: 'BTCGameFields',
    from: { __typename: 'Game', gamePk },
  });

  if (!gameFragment.complete) return null;

  const { data: game } = gameFragment;
  const { away, content, home, pipelines } = game;

  const pipelineContent = getMediaForProvisioning(content);

  return (
    <section className="[--pipelines-container-color:var(--color-background)]">
      <div className="mb-6">
        <p className="mb-4 text-sm">
          Infrastructure that orchestrates the production of media files for a group of Content
        </p>
        {!!pipelineContent?.length && (
          <div className="flex w-max items-center gap-2">
            {pipelineContent?.map((item) => (
              <ProvisionPipelineButton
                key={`provision-btn-${item.mediaId}`}
                content={item}
                game={game}
                pipelines={pipelines}
                scheduleDate={date}
              />
            ))}
          </div>
        )}
      </div>

      {pipelines?.length ? (
        <PipelineList away={away} gamePk={gamePk} home={home} pipelines={pipelines} />
      ) : null}
    </section>
  );
}
